import { bdTrackerAllowedRoles } from 'data/bdTracker/bdTrackerUserRoleValidations';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from 'primereact/skeleton';
import AsyncSelect from 'react-select/async';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import ParallelIterationsModal from '../ParallelIterationModal/ParallelIterationModal';
import AddOpportunityLogic from './AddOpportunity.logic';
import styles from './AddOpportunity.module.scss';
// import debounce from 'lodash.debounce';

const AddOpportunity = ({
  visible,
  boardType,
  closeModal,
}: {
  visible: boolean;
  boardType: string;
  closeModal: () => void;
}) => {
  const {
    searchTerm,
    userModulesRoles,
    newOpportunity,
    setNewOpportunity,
    addOppLoading,
    addTask,
    dropdownDetails,
    addOpportunityResponse,
    handleCLickGoToIteration,
    handleClickCreateNewIteration,
    handleGoToOpportunity: _handleGoToOpportunity,
    fetchSuggestionsWithDelay,
    setSearchTerm,
    checkOpportunityExistsLoading,
    opportuntiyAlreadyExists,
    toggleParallelModalvisibilityForGoToIteration,
    toggleParallelModalvisibilityForIterationCreation,
    isParallelIterationModalOpenForIterationCreation,
    isParallelIterationModalOpenForGoToOpportunity,
  } = AddOpportunityLogic(boardType, closeModal);

  return (
    <Dialog
      headerClassName={styles.modalHeader}
      contentClassName={styles.modalContent}
      header={'Add New Opportunity'}
      style={{ maxWidth: '50vw', minWidth: '40vw', margin: 'auto' }}
      visible={visible}
      onHide={closeModal}
      blockScroll
      draggable={false}
      resizable={false}
    >
      <div className="bdportal bg-white p-5 rounded-lg" style={{ width: '100%' }}>
        <div
          style={{
            marginTop: '0.25rem',
            marginBottom: '1rem',
            width: '100%',
          }}
        >
          <AsyncSelect
            loadOptions={fetchSuggestionsWithDelay}
            onChange={option => {
              setSearchTerm(option?.value || '');
            }}
            maxMenuHeight={500}
            defaultOptions
            placeholder="Search..."
            className="w-full z-1000"
            value={searchTerm ? { label: searchTerm, value: searchTerm } : null}
            isDisabled={addOppLoading}
            styles={{
              // Fixes the overlapping problem of the component
              menu: provided => ({ ...provided, zIndex: 20 }),
            }}
          />
          <Dropdown
            options={
              newOpportunity.iteration_type === 'NC'
                ? dropdownDetails?.NC.Source
                : dropdownDetails?.MAS.Source
            }
            optionLabel="Source"
            optionValue="ID"
            value={newOpportunity?.source_id || ''}
            onChange={e => setNewOpportunity({ ...newOpportunity, source_id: e.value })}
            placeholder="Select Source"
            className={styles.selectDropdown}
            style={{
              margin: '0.5rem 0',
              marginRight: '0.25rem',
              border: '1px solid #00000020',
              width: '100%',
            }}
          />
        </div>

        {/* {searchTerm && <ParallelIterationsTable conceptName={searchTerm} />} */}

        {checkOpportunityExistsLoading ? (
          <Skeleton style={{ width: '100%' }} height={'3rem'} />
        ) : (
          <>
            {opportuntiyAlreadyExists ? (
              <div className="flex flex-col gap-1 mt-4">
                <span className="text-red-500">
                  * Active Opportunity already exists for given molecule
                </span>
                <div className="flex items-center justify-between mt-4">
                  <Button
                    onClick={handleCLickGoToIteration}
                    style={{
                      background: '#522D6E',
                      padding: '0.75rem',
                      color: '#fff',
                    }}
                  >
                    Go to Opportunity
                  </Button>
                  <Button
                    onClick={handleClickCreateNewIteration}
                    style={{
                      background: '#522D6E',
                      padding: '0.75rem',
                      color: '#fff',
                    }}
                  >
                    Create New Iteration
                  </Button>
                </div>
              </div>
            ) : (
              <div className="bdportal flex flex-end mt-4">
                <Button
                  onClick={addTask}
                  style={{
                    background: '#522D6E',
                    padding: '0.75rem',
                    color: '#fff',
                    marginLeft: 'auto',
                  }}
                  disabled={
                    searchTerm === '' ||
                    Boolean(addOpportunityResponse?.old_opportunity_details) ||
                    !checkIfFunctionalityEnabled(
                      bdTrackerAllowedRoles.cardAssigneeChangingDropdown,
                      userModulesRoles.opptracker,
                      userModulesRoles
                    )
                  }
                  loading={addOppLoading}
                >
                  Add Opportunity
                </Button>
              </div>
            )}
          </>
        )}
      </div>

      {isParallelIterationModalOpenForIterationCreation && (
        <ParallelIterationsModal
          visibility={isParallelIterationModalOpenForIterationCreation}
          toggleVisibility={toggleParallelModalvisibilityForIterationCreation}
          conceptName={searchTerm}
          isCreateNewIterationButtonVisible={true}
          isGoToOpportunityButtonVisible={false}
          sourceId={newOpportunity.source_id}
        />
      )}
      {isParallelIterationModalOpenForGoToOpportunity && (
        <ParallelIterationsModal
          visibility={isParallelIterationModalOpenForGoToOpportunity}
          toggleVisibility={toggleParallelModalvisibilityForGoToIteration}
          conceptName={searchTerm}
          isCreateNewIterationButtonVisible={false}
          isGoToOpportunityButtonVisible={true}
        />
      )}
    </Dialog>
  );
};

export default observer(AddOpportunity);
